"use client";

import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger
} from "@/components/ui/dropdown-menu";
import { Laptop, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

const ThemeSwitcher = () => {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme, resolvedTheme } = useTheme();

  // useEffect only runs on the client, so now we can safely show the UI
  useEffect(() => {
    setMounted(true);
  }, []);

  // This effect updates the data-theme attribute on the html element
  useEffect(() => {
    if (mounted) {
      const html = document.documentElement;
      const currentTheme = resolvedTheme || theme;

      // Set data-theme attribute
      html.setAttribute("data-theme", currentTheme || "light");
    }
  }, [theme, resolvedTheme, mounted]);

  if (!mounted) {
    return null;
  }

  const ICON_SIZE = 16;

  // Use resolvedTheme to determine the actual current theme (accounting for system preference)
  const currentTheme = resolvedTheme || theme;

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        {currentTheme === "light" ? (
          <Sun key="light" size={ICON_SIZE} className={"text-muted-foreground"} />
        ) : currentTheme === "dark" ? (
          <Moon key="dark" size={ICON_SIZE} className={"text-muted-foreground"} />
        ) : (
          <Laptop key="system" size={ICON_SIZE} className={"text-muted-foreground"} />
        )}
        <span className="ml-2"> Theme</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuRadioGroup
          value={theme}
          onValueChange={(value) => {
            setTheme(value);
          }}
        >
          <DropdownMenuRadioItem className="flex gap-2" value="light">
            <Sun size={ICON_SIZE} className="text-muted-foreground" /> <span>Light</span>
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem className="flex gap-2" value="dark">
            <Moon size={ICON_SIZE} className="text-muted-foreground" /> <span>Dark</span>
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem className="flex gap-2" value="system">
            <Laptop size={ICON_SIZE} className="text-muted-foreground" /> <span>System</span>
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};

export { ThemeSwitcher };
